import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";
import PitchLinesBackground from "./PitchLinesBackground";

interface RoleCardProps {
  name: string;
  icon: LucideIcon;
  tagline: string;
  description: string;
  ctaLabel: string;
  link: string;
  animationDelay?: number;
  comingSoon?: boolean;
}

const RoleCard = ({ name, icon: Icon, tagline, description, ctaLabel, link, animationDelay = 0, comingSoon = false }: RoleCardProps) => {
  return (
    <Card 
      className="group hover:shadow-2xl hover:shadow-accent/30 transition-all duration-500 hover:-translate-y-3 border border-accent/20 bg-surface/80 backdrop-blur-md overflow-hidden min-h-[420px]"
      style={{ animationDelay: `${animationDelay}ms` }}
    >
      <CardContent className="p-10 flex flex-col h-full relative">
        {/* Coming Soon Badge */}
        {comingSoon && (
          <div className="absolute top-4 right-4 z-20">
            <span className="px-3 py-1 text-xs font-semibold bg-accent/20 text-accent border border-accent/30 rounded-full">
              Coming Soon
            </span>
          </div>
        )}
        
        {/* Pitch Lines Background */}
        <PitchLinesBackground variant="centerCircle" />
        
        <div className="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="relative z-10">
          <div className="mb-6 p-4 border-2 border-accent/50 rounded-2xl w-fit bg-accent/5 group-hover:border-accent group-hover:bg-accent/10 group-hover:scale-110 transition-all duration-500 relative">
            <Icon className="w-12 h-12 text-accent" />
          </div>
          <h3 className="font-heading font-bold text-2xl mb-3 text-foreground">{name}</h3>
          <p className="text-accent font-semibold text-sm mb-4">{tagline}</p>
          <p className="text-muted-foreground text-sm leading-relaxed mb-8 flex-grow">{description}</p>
          <Button asChild className="w-full bg-accent hover:bg-accent-soft transition-all duration-300 shadow-lg shadow-accent/30 hover:shadow-xl hover:shadow-accent/50 text-base py-6">
            <Link to={link}>{ctaLabel}</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default RoleCard;
